export default {
  root: {
    minHeight: 200,
  },
};
